import React from 'react'
import { CustomTable } from 'src/component'
import { useQuery } from '@tanstack/react-query';
import { getOneCustomers } from 'src/services/api';
import { Link, useParams } from 'react-router-dom';
import { formatCustomDate } from 'src/utils/functions';

const CustomerDetails = () => {
    const { userId } = useParams();

    const { data } = useQuery({
        queryKey: ["user"],
        queryFn: () => getOneCustomers(userId),
        suspense: true,
    });

    const columns = [
        {
            name: "S/N",
            cell: (_, i) => i + 1,
            width: "6%"
        },
        {
            name: "Name",
            cell: (row) => <div className='capitalize'>{row?.appliance_name}</div>,
            grow: 2
        },
        {
            name: "Minimum Rating",
            cell: (row) => row?.minRating + " Watt(s)",

        },
        {
            name: "Maximum Rating",
            cell: (row) => row?.maxRating + " Watt(s)",

        },
        {
            name: "Quantity",
            cell: (row) => row?.qty,
            grow: 0.5

        },
        {
            name: "Time of Use ",
            cell: (row) => row?.energy_usage_label,

        },
        {
            name: "Necessity",
            cell: (row) => row?.priority_label,

        },
        {
            name: "Average Daily Usage (hours)",
            cell: (row) => row?.avg_daily_usage,
            grow: 1.5

        },
        {
            name: "Status",
            cell: (row) => <div className='capitalize'>{row?.status}</div>,


        },
    ];


    return (
        <>
            <div className="flex items-center justify-between mb-[3rem]">
                <p className="text-[2.5rem] font-medium text-defaultPrimary">Customer Enquires</p>
                <Link to="/admin/customers" className="text-[1.6rem] font-medium text-[#6E7079] cursor-pointer hover:text-defaultPrimary" >Back</Link>
            </div>

            <div className='flex items-center gap-[2rem] flex-wrap'>
                <div className='text-[1.6rem] font-medium text-[#343A40]'><span className='text-[#6E7079] text-[1.5rem] pr-[.5rem]'>Name:</span>{data?.data?.fullName}</div>
                <div className='text-[1.6rem] font-medium text-[#343A40]'><span className='text-[#6E7079] text-[1.5rem] pr-[.5rem]'>Email:</span>{data?.data?.email}</div>
                <div className='text-[1.6rem] font-medium text-[#343A40]'><span className='text-[#6E7079] text-[1.5rem] pr-[.5rem]'>Phone number:</span>{data?.data?.phoneNumber}</div>
            </div>

            <div>
                {data?.data?.data?.map((applianceGroup, idx) => {
                    const appliances = Object.values(applianceGroup)[0];

                    return (
                        <div key={idx} className='my-[3rem] border-b-lightGrey'>
                            <div className='flex flex-wrap space-y-4 justify-between my-[2rem]'>
                                <p className='text-[1.6rem]  text-lightGrey'>{formatCustomDate(Object.keys(applianceGroup)[0])}</p>
                                <p className='text-[1.6rem] text-right text-defaultPrimary'>Energy Usage: {appliances?.energy_usage} Watt(s)</p>
                            </div>
                            <CustomTable
                                columns={columns}
                                data={appliances?.appliances}
                                pagination={false}
                            />
                        </div>
                    );
                })}
            </div>
        </>
    )
}

export default CustomerDetails;